import { render, staticRenderFns } from "./promotionList.vue?vue&type=template&id=4e67e325&scoped=true"
import script from "./promotionList.vue?vue&type=script&lang=js"
export * from "./promotionList.vue?vue&type=script&lang=js"
import style0 from "./promotionList.vue?vue&type=style&index=0&id=4e67e325&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e67e325",
  null
  
)

export default component.exports